import { SxProps } from '@mui/material';

import { getTheme } from '@sh4res/bo-common/theme';

/**
 * Returns appropriate AppBar background gradient style based on environment and sidebar state
 */
export const getAppBarBackgroundStyle = (isOpen: boolean): SxProps => {
  if (getTheme() === 'axa') {
    // Axa environments use white background gradients
    return {
      backgroundImage: isOpen
        ? 'linear-gradient(to right, white 240px, rgba(0,0,0,0) 240px)'
        : 'linear-gradient(to right, white 50px, rgba(0,0,0,0) 50px)',
    };
  }

  // Standard environments use black background gradients
  return {
    backgroundImage: isOpen
      ? 'linear-gradient(to right, black 240px, rgba(0,0,0,0) 240px)'
      : 'linear-gradient(to right, black 50px, rgba(0,0,0,0) 50px)',
  };
};

/**
 * Returns appropriate title padding style based on environment and sidebar state
 */
export const getTitlePaddingStyle = (isOpen: boolean): SxProps => {
  const commonStyle = {
    paddingTop: '10px',
    width: '100%',
    '& .RaConfigurable-root': {
      display: 'block',
    },
    fontSize: '17px',
    fontWeight: 600,
  };

  return isOpen
    ? { ...commonStyle, paddingLeft: ['axa'].includes(getTheme()) ? '158px' : '87px' }
    : { ...commonStyle, paddingLeft: '15px' };
};
